import { render, staticRenderFns } from "./popup-do-she-bei.vue?vue&type=template&id=09fca015&scoped=true"
import script from "./popup-do-she-bei.vue?vue&type=script&lang=js"
export * from "./popup-do-she-bei.vue?vue&type=script&lang=js"
import style0 from "./popup-do-she-bei.vue?vue&type=style&index=0&id=09fca015&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09fca015",
  null
  
)

export default component.exports